export const lenisStore = { current: null };

export function scrollToId(id) {
    const target = document.getElementById(id);
    if (!target) return;
    if (lenisStore.current) {
        lenisStore.current.scrollTo(target, { offset: -72, duration: 1.4 });
    } else {
        target.scrollIntoView({ behavior: "smooth" });
    }
}
